/** @format */

export const germanShippingHelpArticle =
    'https://intercom.help/mpbcom-de/de/articles/4359949-was-sind-meine-lieferoptionen';

export const usPrinterHelpArticle =
    'https://intercom.help/mpbcom-us/en/articles/6024903-do-i-need-a-printer-to-sell-to-mpb';

export const frPrinterHelpArticle =
    'https://intercom.help/mpbcom-fr/fr/articles/6294514-ai-je-besoin-d-une-imprimante-pour-vendre-a-mpb';

export const xcoverTrustPilotLink =
    'https://www.trustpilot.com/review/xcover.com';
